import React from 'react'

import useSearchFilter from '~/hooks/useSearchFilter'
import {EmptyDropdownMenuItemLabel} from './EmptyDropdownMenuItemLabel'
import Menu from './Menu'
import {SearchMenuItem} from './SearchMenuItem'
import TaskIntegrationMenuItem from './TaskIntegrationMenuItem'







const getValue = (item) => {
  return item.fullPath || 'Unknown Project'
}

const NewGitLabIssueMenu = (props) => {
  const {handleSelectFullPath, menuProps, gitlabProjects} = props

  const {
    query,
    filteredItems: filteredProjects,
    onQueryChange
  } = useSearchFilter(gitlabProjects, getValue)

  return (
    React.createElement(Menu, { ariaLabel: "Select GitLab project"  , keepParentFocus: true, ...menuProps,}
      , React.createElement(SearchMenuItem, { placeholder: "Search GitLab" , onChange: onQueryChange, value: query,} )
      , filteredProjects.length === 0 && (
        React.createElement(EmptyDropdownMenuItemLabel, { key: "no-results",}, "No projects found!"  )
      )
      , filteredProjects.slice(0, 10).map((project) => {
        const {id: projectId, fullPath} = project
        const onClick = () => {
          handleSelectFullPath(fullPath)
        }
        return (
          React.createElement(TaskIntegrationMenuItem, {
            key: projectId,
            label: fullPath,
            onClick: onClick,
            query: query,
            service: "gitlab",}
          )
        )
      })
    )
  )
}

export default NewGitLabIssueMenu
